import { render, staticRenderFns } from "./AnnotatableSource.vue?vue&type=template&id=52cc2c28&scoped=true&"
import script from "./AnnotatableSource.vue?vue&type=script&lang=js&"
export * from "./AnnotatableSource.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatableSource.vue?vue&type=style&index=0&id=52cc2c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc2c28",
  null
  
)

export default component.exports